import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import CustomIcon from 'shared/components/customIcon'

import * as styles from './styles'

const sportTypes = [
	{ id: null, name: 'All', icon: null },
	{ id: 'BASKETBALL', name: 'Basketball', icon: 'BASKETBALL' },
	{ id: 'BASEBALL', name: 'Baseball', icon: 'BASEBALL' },
	{ id: 'SOCCER', name: 'Soccer', icon: 'SOCCER' },
	{ id: 'HOCKEY', name: 'Hockey', icon: 'HOCKEY' },
	{ id: 'FOOTBALL', name: 'Football', icon: 'FOOTBALL' },
	{ id: 'FOOTBALL_NZ', name: 'Football NZ', icon: 'FOOTBALL_NZ' },
	{ id: 'ATHLETICS', name: 'Athletics', icon: 'ATHLETICS' },
	{ id: 'OTHER', name: 'Other', icon: 'OTHER' },
]

const MobileFiltersComponent = ({ selectedSportType, onSportTypeChange }) => {
	return (
		<div css={styles.container}>
			<div css={styles.filtersWrapper}>
				{sportTypes.map((sport) => {
					const isSelected = selectedSportType === sport.id

					return (
						<button
							key={sport.id || 'all'}
							css={[styles.filterPill, isSelected && styles.filterPillActive]}
							onClick={() => onSportTypeChange(sport.id)}
							type="button"
						>
							{sport.icon && (
								<CustomIcon
									icon={sport.icon}
									size={28}
									style={isSelected ? styles.filterIconActive : styles.filterIcon}
								/>
							)}
							<Text
								size={12}
								medium
								css={[styles.filterText, isSelected && styles.filterTextActive]}
							>
								{sport.name}
							</Text>
						</button>
					)
				})}
			</div>
		</div>
	)
}

MobileFiltersComponent.propTypes = {
	selectedSportType: PropTypes.string,
	onSportTypeChange: PropTypes.func.isRequired,
}

export default MobileFiltersComponent 